const SITEMAP_LEVELS = {
  MANAGER: 'MANAGER',
  JOURNEYS: 'JOURNEYS',
} as const;

type SitemapLevel = (typeof SITEMAP_LEVELS)[keyof typeof SITEMAP_LEVELS];

export { SITEMAP_LEVELS };
export type { SitemapLevel };
